<template>
  <div class="KasrKarDetails">
    <v-row>
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblTedadeTakhir") }}:<span
          class="text-value"
          >{{ details.NW_LATECNT }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblTakhireKol") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.NW_LATE) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblTedadeTajil") }}:<span
          class="text-value"
          >{{ details.NW_EARLYCNT }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblTajileKol") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.NW_EARLY) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.KasrKarDetails.lblTedadeKhorojegheireMojaz")
        }}:<span class="text-value">{{
          details.NW_LEAVENOTPERMCNT
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.KasrKarDetails.lblKhorojeGheireMojaz")
        }}:<span class="text-value">{{ ConvertMinuteToHour(details.NW_LEAVENOTPERM) }}</span></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblTedadegheibat") }}:<span
          class="text-value"
          >{{ details.NW_ABSENTCNT }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblgheibatKol") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.NW_ABSENT) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblKasrekarVijhe") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.NW_SPECIAL) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.KasrKarDetails.lblMajmoeKasreKar") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.NONWORKTOTAL) }}</span
        ></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["details"],
};
</script>

<style>
</style>